/* eslint-disable promise/param-names */
import { AUTH_REQUEST, AUTH_ERROR, AUTH_SUCCESS, AUTH_LOGOUT } from '../actions/auth'
import { USER_REQUEST } from '../actions/user'
import axios from 'axios'
import decode from 'jwt-decode';
import {getUserACLs, setUserACLs, unsetUserACLs} from '../persist/acl'
const API_URL = process.env.VUE_APP_API_URI || 'http://localhost:3000/api/v1'

export const HTTP = axios.create({
  baseURL: API_URL,
  headers: {
    'Content-Type': 'application/json',
    'Authorization': 'Bearer ' + localStorage.token
  }
})

const state = { 
	token: localStorage.getItem('shareXToken') || '', 
	status: '', 
	userdata: JSON.parse(localStorage.getItem('userData')) || {acls:[]},
	hasLoadedOnce: false,
	loggedout: false
 }

const getters = {
  isAuthenticated: state => !!state.token,
	authStatus: state => state.status,
	hasLoggedOut: state => state.loggedout,
	useracls: state => state.userdata.acls,
	userdata: state => state.userdata
}

const actions = {
  'AUTH_REQUEST': ({commit, dispatch}, user) => {
    return new Promise((resolve, reject) => { // The Promise used for router redirect in login
      commit(AUTH_REQUEST)
      HTTP.post('/login',user)
        .then(resp => {
					if(resp.data.error) {
						resolve({'loginError':resp.data.error})
					}
					else {
						const token = resp.data.token
						localStorage.setItem('shareXToken', token) // store the token in localstorage
						const decodedToken = decode(resp.data.token);
						var userdata = decodedToken.context.user
						userdata.acls.push('isloggedin')
						console.log('set ', userdata)
						setUserACLs(userdata.acls)
						localStorage.setItem('userData', JSON.stringify(userdata)) // store the token in localstorage
						HTTP.defaults.headers.common['Authorization'] = 'Bearer ' + resp.data.token;
						commit(AUTH_SUCCESS,{'token': token, 'userdata': userdata})
						// you have your token, now log in your user :)
						resolve(resp)
						}
        })
      .catch(err => {
        commit(AUTH_ERROR, err)
        localStorage.removeItem('shareXToken') // if the request fails, remove any possible user token if possible
        reject(err)
      })
    })
  },
  [AUTH_LOGOUT]: ({commit, dispatch}) => {
    return new Promise((resolve, reject) => {
			commit(AUTH_LOGOUT)
			console.log("Logged out")
			console.log(state.loggedout)
			unsetUserACLs()
      localStorage.removeItem('shareXToken')
      localStorage.removeItem('userData')
      resolve()
    })
  }
}

const mutations = {
  [AUTH_REQUEST]: (state) => {
    state.status = 'loading'
  },
  [AUTH_SUCCESS]: (state, resp) => {
    state.status = 'success'
    state.token = resp.token
    state.userdata = resp.userdata
		state.hasLoadedOnce = true
  },
  [AUTH_ERROR]: (state) => {
    state.status = 'error'
    state.hasLoadedOnce = true
  },
  [AUTH_LOGOUT]: (state) => {
		state.token = ''
    state.userdata = {acls:[]}
		state.loggedout = true
  }
}

export default {
  state,
  getters,
  actions,
  mutations,
}
